import { useState, useEffect } from "react";
import { Newspaper, ArrowSquareOut } from "@phosphor-icons/react";
import { fetchNews } from "../lib/api";

export default function NewsSection() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews().then((data) => setArticles(data.articles || [])).finally(() => setLoading(false));
  }, []);

  if (loading || !articles.length) return null;

  return (
    <section data-testid="news-section" className="mb-8 border border-zinc-800">
      <div className="bg-[#111] text-white px-4 py-3 flex items-center gap-2">
        <Newspaper weight="bold" size={16} className="text-[#D4AF37]" />
        <span className="mono-label text-[#D4AF37]">Racing News</span>
      </div>
      <div className="divide-y divide-zinc-800">
        {articles.slice(0, 6).map((a, i) => (
          <a
            key={i}
            href={a.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`news-article-${i}`}
            className="flex items-start justify-between gap-3 p-3 hover:bg-zinc-800/50 transition-colors group"
          >
            <div className="flex-1">
              <p className="text-sm font-semibold text-white group-hover:text-[#D4AF37] transition-colors">{a.title}</p>
              {a.summary && <p className="text-xs text-zinc-500 mt-0.5 line-clamp-1">{a.summary}</p>}
              <div className="flex items-center gap-2 mt-1">
                <span className="text-[10px] font-mono text-zinc-400 bg-zinc-800 px-1.5 py-0.5">{a.source}</span>
                {a.published && <span className="text-[10px] text-zinc-500">{a.published}</span>}
              </div>
            </div>
            <ArrowSquareOut weight="bold" size={14} className="text-zinc-600 mt-1 flex-shrink-0" />
          </a>
        ))}
      </div>
    </section>
  );
}
